import React from "react";
import PropTypes from "prop-types";

// CumulativeToggle — the DISPLAY mode of the time-series: per-bucket values
// ("which months drove the spend?") or a running total ("where will we finish?").
//
// Deliberately separate from IntervalSelect rather than a fourth item inside it:
// granularity and accumulation are different kinds of setting, and keeping them
// independent is what makes Monthly + Cumulative — the YTD pacing view — reachable.
//
// It lives on the chart rather than the page toolbar (with Breakdown and Basis)
// because it changes only the one time-series it sits on; Breakdown, Basis and
// filters redefine the whole analyzer including the drivers table and attribution panel.
export default function CumulativeToggle({ checked, onChange }) {
  return (
    <label className="flex cursor-pointer select-none items-center gap-1.5 text-[12px] text-text-2">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="cursor-pointer accent-[hsl(var(--chart-1))]"
        style={{ width: 14, height: 14 }}
      />
      Cumulative
    </label>
  );
}

CumulativeToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
